import * as React from 'react';
import SVGInline from 'react-svg-inline';
import * as styles from './FaqSearch.scss';
import { IFaqItems } from '@/api/faq';
import searchIcon from '@/assets/images/search.svg';
import { useEffect } from 'react';
import { useClickedOutside } from '@/hooks/useClickedOutside';
import { Button, ButtonType } from '@/components/common/button/Button';
import { IconType } from '@/components/common/icon/Icon';

interface IFaqSearch {
    faqItems: IFaqItems[];
    placeholderLabel: string;
    handleTabClick: (index: number, id: number) => () => void;
}

export const FaqSearch: React.FC<IFaqSearch> = ({ placeholderLabel, faqItems, handleTabClick }) => {
    const faqSearchSuggestionListRef = React.useRef(null);
    const [query, setQuery] = React.useState<string>('');
    const [visible, setVisibility] = React.useState(false);

    const handleSetQuery = (e: React.ChangeEvent<HTMLInputElement>) => setQuery(e.target.value);
    const setVisible = (isVisible: boolean) => () => setVisibility(isVisible);
    const setClearInput = () => setQuery('');

    const shouldShowSuggestionList = visible && query !== '';
    const filteredFaqItems = faqItems.map(faqItem =>
        faqItem.items.filter(item => (query !== '' ? item.question.toLowerCase().includes(query.toLowerCase()) : ''))
    );

    useEffect(() => {
        setVisible(true)();
    }, [query !== '']);

    useClickedOutside(faqSearchSuggestionListRef, setVisible(false));

    const handleItemClick = (index: number, id: number) => () => {
        handleTabClick(index, id)();
        setVisible(false)();
        setQuery('');
    };

    return (
        <div className={styles.faqSearch}>
            {query === '' ? (
                <SVGInline className={styles.faqSearchIcon} svg={searchIcon} />
            ) : (
                <Button
                    type={ButtonType.ICON_BUTTON}
                    iconType={IconType.ICON_CROSS}
                    classes={styles.faqSearchClearBtn}
                    onClick={setClearInput}
                />
            )}
            <input
                onChange={handleSetQuery}
                className={styles.faqSearchInput}
                placeholder={placeholderLabel}
                value={query}
                onFocus={setVisible(true)}
            />
            {shouldShowSuggestionList && (
                <div ref={faqSearchSuggestionListRef} className={styles.faqSearchSuggestionList}>
                    {filteredFaqItems.map((filteredItem, index) =>
                        filteredItem.map(item => (
                            <div
                                onClick={handleItemClick(index, item.id)}
                                className={styles.faqSearchSuggestionListItem}
                                key={item.id}
                            >
                                {item.question}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default FaqSearch;
